module.exports = __webpack_public_path__ + "img/richard-smc.5d4b7ccb.jpg";